import React, { useState } from "react";
import { Row, Col, Card, Form, Table } from "react-bootstrap";
import {
    FaPhone,
    FaEnvelope,
    FaUserTie,
    FaMapMarkerAlt,
    FaTable,
    FaTh
} from "react-icons/fa";

import hotelData from "../data/JTDCLOutsourcedUnitsData";
import selfRunData from "../data/JTDCLSelfrunUnitsData";

import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const HotelOutsourced = () => {
    const [hotelType, setHotelType] = useState("outsourced");
    const [place, setPlace] = useState("");
    const [viewMode, setViewMode] = useState("card"); // "card" or "table"

    const currentData = hotelType === "outsourced" ? hotelData : selfRunData;
    const places = [...new Set(currentData.map(item => item.place))];
    const filteredData = place
        ? currentData.filter(item => item.place === place)
        : currentData;

    // selfrun ke liye table view auto set karo
    const effectiveView = hotelType === "selfrun" ? "table" : viewMode;

    const handleDownloadPDF = () => {
        const doc = new jsPDF();
        let startY = 20;
        let slNo = 1;

        doc.setFontSize(14);
        doc.text(
            hotelType === "outsourced"
                ? "Outsourced Hotels & Properties"
                : "Self Run Hotels & Properties",
            105, 10, { align: "center" }
        );

        const tableData = filteredData.map(item => [
            slNo++,
            item.name,
            item.operator,
            item.mobile || "N/A",
            item.email || "N/A",
            item.place
        ]);

        autoTable(doc, {
            startY,
            head: [["SL No", "Hotel Name", "Operator", "Mobile", "Email", "District"]],
            body: tableData,
            didDrawPage: function () { startY = 20; },
            styles: { fontSize: 8, cellPadding: 2 },
            columnStyles: {
                0: { cellWidth: 10 },
                1: { cellWidth: 45 },
                2: { cellWidth: 40 },
                3: { cellWidth: 25 },
                4: { cellWidth: 40 },
                5: { cellWidth: 25 }
            },
            headStyles: { fillColor: [220, 220, 220], textColor: 0, align: "justify" },
            theme: "grid",
            margin: { left: 10, right: 10 }
        });

        doc.save(
            hotelType === "outsourced"
                ? "Outsourced_Hotels.pdf"
                : "Self_Run_Hotels.pdf"
        );
    };

    return (
        <div className="container my-4">

            {/* Heading */}
            <h3
                className="mb-4 text-center display-6 display-md-5"
                style={{ fontFamily: '"EB Garamond", serif' }}
            >
                JTDCL Outsourced / Self Run Hotels & Properties
            </h3>

            {/* Filters */}
            <Row className="mb-4">
                <Col xs={12} md={4} className="mb-2">
                    <Form.Select
                        value={hotelType}
                        onChange={(e) => {
                            setHotelType(e.target.value);
                            setPlace("");
                        }}
                    >
                        <option value="outsourced">Outsourced Hotels & Properties</option>
                        <option value="selfrun">Self Run Hotels & Properties</option>
                    </Form.Select>
                </Col>

                <Col xs={12} md={4}>
                    <Form.Select
                        value={place}
                        onChange={(e) => setPlace(e.target.value)}
                    >
                        <option value="">All Places</option>
                        {places.map((p, i) => (
                            <option key={i} value={p}>{p}</option>
                        ))}
                    </Form.Select>
                </Col>
            </Row>

            {/* Toolbar */}
            <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">

                <div className="fw-semibold text-secondary">
                    {place ? (
                        <>
                            Showing{" "}
                            <span className="text-primary">{filteredData.length}</span>
                            {" "}in{" "}
                            <span className="text-dark">{place}</span>
                        </>
                    ) : (
                        <>
                            Total Properties:{" "}
                            <span className="text-primary">{filteredData.length}</span>
                        </>
                    )}
                </div>

                <div className="d-flex gap-2 align-items-center">
                    {/* View Toggle — sirf outsourced ke liye dikhao */}
                    {hotelType === "outsourced" && (
                        <div className="btn-group" role="group">
                            <button
                                className={`btn btn-sm ${viewMode === "card" ? "btn-primary" : "btn-outline-primary"}`}
                                onClick={() => setViewMode("card")}
                                title="Card View"
                            >
                                <FaTh />
                            </button>
                            <button
                                className={`btn btn-sm ${viewMode === "table" ? "btn-primary" : "btn-outline-primary"}`}
                                onClick={() => setViewMode("table")}
                                title="Table View"
                            >
                                <FaTable />
                            </button>
                        </div>
                    )}

                    <button className="btn btn-outline-primary" onClick={handleDownloadPDF}>
                        Download PDF
                    </button>
                </div>
            </div>

            {/* ================= TABLE VIEW ================= */}
            {effectiveView === "table" && (
                <div className="table-responsive">
                    <Table bordered hover className="align-middle">
                        <thead className="table-dark text-center">
                            <tr>
                                <th style={{ width: "50px" }}>SL No</th>
                                <th>Property Name</th>
                                <th>Operator</th>
                                <th>Mobile</th>
                                <th>Email</th>
                                <th>Place / District</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredData.length > 0 ? (
                                filteredData.map((item, index) => (
                                    <tr key={index}>
                                        <td className="text-center">{index + 1}</td>
                                        <td className="fw-semibold">{item.name}</td>
                                        <td>{item.operator}</td>
                                        <td>
                                            {item.mobile ? (
                                                <a href={`tel:${item.mobile}`} className="text-decoration-none">
                                                    <FaPhone size={12} className="me-1 text-danger" />
                                                    {item.mobile}
                                                </a>
                                            ) : (
                                                <span className="text-muted">N/A</span>
                                            )}
                                        </td>
                                        <td>
                                            {item.email ? (
                                                <a href={`mailto:${item.email}`} className="text-decoration-none text-truncate d-inline-block" style={{ maxWidth: "200px" }}>
                                                    <FaEnvelope size={12} className="me-1 text-primary" />
                                                    {item.email}
                                                </a>
                                            ) : (
                                                <span className="text-muted">N/A</span>
                                            )}
                                        </td>
                                        <td>
                                            <FaMapMarkerAlt size={12} className="me-1 text-success" />
                                            {item.place}
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={6} className="text-center text-muted py-4">
                                        No properties found.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </div>
            )}

            {/* ================= CARD VIEW ================= */}
            {effectiveView === "card" && (
                <>
                    <Row className="g-4">
                        {filteredData.map((item, index) => (
                            <Col lg={4} md={6} sm={12} key={index}>
                                <Card
                                    className="h-100 shadow-sm border-0"
                                    style={{ transition: "0.2s ease" }}
                                    onMouseEnter={e => e.currentTarget.style.transform = "translateY(-4px)"}
                                    onMouseLeave={e => e.currentTarget.style.transform = "translateY(0)"}
                                >
                                    <Card.Img
                                        variant="top"
                                        src={item.image || "/images/default-hotel.jpg"}
                                        style={{ height: "200px", objectFit: "cover" }}
                                        onError={(e) => { e.target.src = "/images/default-hotel.jpg"; }}
                                    />
                                    <Card.Body className="d-flex flex-column">
                                        <Card.Title className="fw-bold text-secondary mb-2" style={{ fontSize: "1.1rem" }}>
                                            {item.name}
                                        </Card.Title>
                                        <div className="mb-2 d-flex align-items-center gap-2">
                                            <FaUserTie size={13} className="text-secondary" />
                                            <span>{item.operator}</span>
                                        </div>
                                        <div className="mb-2 d-flex align-items-center gap-2">
                                            <FaPhone size={13} className="text-danger" />
                                            <span>{item.mobile || "N/A"}</span>
                                        </div>
                                        <div className="mb-2 d-flex align-items-center gap-2">
                                            <FaEnvelope size={13} className="text-primary" />
                                            <span className="text-truncate d-inline-block" style={{ maxWidth: "100%" }}>
                                                {item.email || "N/A"}
                                            </span>
                                        </div>
                                        <div className="mt-auto pt-2 border-top d-flex align-items-center gap-2">
                                            <FaMapMarkerAlt size={13} className="text-success" />
                                            <small>{item.place}</small>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))}
                    </Row>

                    {filteredData.length === 0 && (
                        <div className="text-center mt-5 text-muted">No properties found.</div>
                    )}
                </>
            )}

        </div>
    );
};

export default HotelOutsourced;